import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatFechaDesplieguePipe',
  pure: false
})
export class FormatFechaDesplieguePipe implements PipeTransform {
  transform(items: any, anno, mes, dia): any {
    if (!anno || !mes || !dia) {
      return '';
    }

    let mesStr;
    if (mes < 10) {
      mesStr = '0' + mes;
    } else {
      mesStr = '' + mes;
    }

    let diaStr;
    if (dia < 10) {
      diaStr = '0' + dia;
    } else {
      diaStr = '' + dia;
    }


    return diaStr + '/' + mesStr + '/' + anno;
  }
}
